import React, {Component} from 'react';
import './ContactInfo.css';
import {Form, Input} from 'antd';

const { TextArea } = Input;

class ContactInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name:""
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 7 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12 },
            },
        };

        return (
            <div class="contactInfo-container">
                <Form {...formItemLayout}>
                    <Form.Item
                        label="Cep Telefonu:">
                        <Input maxlength={11} value= {this.props.memberInfo.gsmTel}  placeholder="Cep Telefonunuz" allowClear  onChange={(e)=>this.props.onInfoChange("gsmTel",e.target.value)} />
                    </Form.Item>
                    <Form.Item
                        label="Ev Telefonu">
                        <Input maxlength={11} value= {this.props.memberInfo.evTel}   placeholder="Ev Telefonunuz" allowClear onChange={(e)=>this.props.onInfoChange("evTel",e.target.value)} />
                    </Form.Item>
                    <Form.Item
                        label="İş Yeri Telefonu:">
                        <Input maxlength={11} value= {this.props.memberInfo.isTel}  placeholder="İş Yeri Telefonunuz" allowClear onChange={(e)=>this.props.onInfoChange("isTel",e.target.value)} />
                    </Form.Item>

                    <Form.Item
                        label="İş Yeri Adresi:">
                        <TextArea maxlength={255} rows={4}  value= {this.props.memberInfo.isAdres} placeholder="Adres Giriniz"  onChange={(e)=>this.props.onInfoChange("isAdres",e.target.value)}/>
                    </Form.Item>

                    <Form.Item
                        label="İkamet Adresi:">
                        <TextArea maxlength={255} rows={4}  value= {this.props.memberInfo.ikametAdres} placeholder="Adres Giriniz"  onChange={(e)=>this.props.onInfoChange("ikametAdres",e.target.value)}/>
                    </Form.Item>



                </Form>
            </div>
        );
    }


}
export default ContactInfo;



// WEBPACK FOOTER //
// ./src/page/contactInfo/ContactInfo.js